import { createStore } from "vuex";
import { account } from "./account.module";
import { global } from "./global.module";
import { user } from "./user.module";
import { superUser } from "./superUser.module";
import { productGroup } from "./productgroup.module";
import { product } from "./product.module";
import { table } from "./table.module";
import { analytics } from "./analytics.module";
import { printer } from "./printer.module";
import { organisation } from "./organisation.module";
import { shift } from "./shift.module";
import { stock } from "@/store/stock.module";
import { client } from "@/store/client.module";
import { invoice } from "@/store/invoice.module";
import {workerShift} from "@/store/workerShift.module";
import {kitchen} from "@/store/kitchen.module"
import {images} from "@/store/image.module";
import {imageService} from "@/services/ImageService";
import {promo} from "@/store/promo.module";
import {pickup} from "@/store/pickup.module";
import {deliveryArea} from "@/store/deliveryArea.module";
import {integration} from "@/store/integration.module";
import {device} from "@/store/device.module";
import {playlist} from "@/store/playlist.module";
import {icons} from "@/store/icon.module";
import {productOption} from "@/store/productOption.module";
import {voucher} from "@/store/voucher.module";
import {preferences} from "@/store/preferences.module";
import {view} from "@/store/view.module";
import {aiDebugger} from "@/store/aiDebugger.module";
import {catalogImport} from "@/store/catalogImport.module";


const store = createStore({
  modules: {
    account,
    global,
    user,
    superUser,
    productGroup,
    product,
    integration,
    table,
    analytics,
    printer,
    organisation,
    shift,
    stock,
    client,
    invoice,
    pickup,
    deliveryArea,
    device,
    workerShift,
    kitchen,
    images,
    promo,
    playlist,
    icons,
    voucher,
    preferences,
    productOption,
    view,
    aiDebugger,
    catalogImport
  },
});

imageService.onImageUploaded(() => store.commit('images/invalidateImages'));

export default store;
